import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AUTO_LOGOUT_TIME = 30 * 60 * 1000; // 2 minutes in milliseconds

const AutoLogout = () => {
  const navigate = useNavigate();
 
  useEffect(() => {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      navigate("/");
      return;
    }

    let logoutTimer;

    // Function to reset the inactivity timer
    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(handleLogout, AUTO_LOGOUT_TIME);
    };

    // Function to log out the user
    const handleLogout = () => {
      console.log("User is idle. Logging out...");
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    };

    // Attach event listeners to track user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer(); // Start timer

    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [navigate]);

  return null; // No UI required
};

export default AutoLogout;
